
import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { CatalogoProblemasService } from './service/catalogo-problemas.service';
import { CatalogoData, CatalogoResponse } from './interface/catalogo-problemas.interface';
import { CreateChatService } from '../../service/create-chat.service';

@Component({
  selector: 'chat-call-center-catalogo-problemas',
  imports: [],
  templateUrl: './catalogo-problemas.component.html',
  styleUrl: './catalogo-problemas.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogoProblemasComponent implements OnInit {
  catalogos = signal<CatalogoData[]>([]);
  @Output() selectedProblem = new EventEmitter<string>();
  selectedProblemData = signal<CatalogoData | null>(null);

  constructor(private catalogoProblemasService: CatalogoProblemasService,
    private createChatService: CreateChatService
  ) {

  }
  ngOnInit(): void {
    this.loadCatalogos();
  }
  loadCatalogos(): void {
    this.catalogoProblemasService.loadCatalogo().subscribe({
      next: (response:CatalogoResponse) => {
        // console.log('catalogo:', response);
        this.catalogos.set(response.data);
      },
      error: (error) => {
        this.catalogos.set([]);
      }
    })
  }

  selectProblem(catalogo: CatalogoData): void {
    this.selectedProblemData.set(catalogo);
    this.selectedProblem.emit(catalogo.name);
    // console.log('Problema seleccionado:', catalogo);
    // Aquí puedes agregar lógica adicional como emitir un evento o navegar
  }

}
